import ApplicationState from "@insite/client-framework/Store/ApplicationState"
import { ProductModel } from "@insite/client-framework/Types/ApiModels"

type CustomApplicationState = ApplicationState & {
  allProducts: {
    products: ProductModel[];
  };
};

export function getAllProductsState(state: CustomApplicationState) {
  return state?.allProducts?.products;
}